<template>
  <div class="hot_div">
    <div class="hot_list">
      <div class="flex_between div_title">
        <h4 class="title">评论</h4>
        <div class="flex_center title_right">
          <span class="del" @click="del" v-if="state">删除</span>
          <button class="flex_center" @click="state = !state" :class="{'state':state}">
            <span v-if="!state">管理</span>
            <span v-else>取消</span>
          </button>
        </div>
      </div>
      <div class="list_ul recommended_list" v-if="list_ul.length>0">
        <div class="recommended_li flex_between" @click="detailsFun(index,liem)" v-for="(liem,index) in list_ul"
          :key="index">
          <i class="gou_icon" v-if="state">
            <img v-if="!liem.is_selected" src="@/assets/img/gou.png" alt="">
            <img v-else src="@/assets/img/gouT.png" alt="">
          </i>
          <i class="mark" v-if="!state"></i>
          <span class="time">{{liem.create_time}}</span>
          <div class="text" v-if="liem.type == 1" v-html="liem.content">

          </div>
          <div class="text li_r_img" v-if="liem.type == 2">
            <img :src="liem.content" alt="">
          </div>
        </div>
      </div>
      <div class="flex_center no_center" v-else>
        <i v-if="is_loading"><img src="@/assets/img/kkry_pc.gif" alt=""></i>
        <div class="flex_center prompt_text" v-if="is_loading">
          暂无评论，前往推荐看看吧! <a href="javaScript:void(0)" @click.stop="geHome">推荐</a>
        </div>
        <div v-else class="flex_center prompt_text">
            加载中...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'popup',
    data() {
      return {
        state: false,//管理状态
        user: {},//用户信息
        list_ul: [],
        page: 1,
        is_loading:false,
      }
    },
    props: {

    },
    watch: {

    },
    methods: {
      detailsFun(index,item) {
         
        if (this.state) {
          this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
          this.reinstall();
        } else {
          if(item.news_id!==0){
          this.$router.push({ path: '/column_details', query: { id: item.news_id, head_index: 2 } });
          }else if(item.video_id!==0){
          this.$router.push({ path: '/vedio_detil', query: { id: item.video_id,configid:item.conf_id} });
          }else if(item.meeting_id!==0){

          }
        }
      },
      addImg() {
        $('.li_r_img img').on("click", function () {
           
          $(this).ImgZoomIn('');
        });
      },
      del() {//删除关注
        let that = this;
        let arr = [];
        this.list_ul.forEach((liem, index) => {
          if (liem.is_selected) {
            arr.push(liem.id)
          }
        })
        if (arr.length > 0) {
          layer.open({
            content: '您确认删除这些评论吗？'
            , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
            , btn: ['确定', '取消']
            , yes: function (index) {
              layer.close(index);
              that.$post('comment_del', {
                comment_id: arr.join(","),
                member_id: that.USER().id,
              }).then(res => {
                layer.open({
                  content: "删除成功",
                  time: true,
                  skin: "msg"
                });
                that.state = false;
                that.page = 1;
                that.getList();
                that.$parent.beiChildMethod();
              })
            }
          })
        }

      },
      geHome: function () {
        this.$router.replace('/');
      },
      getList() {
        let that = this;
        if (this.page == 1) {
          this.list_ul = [];
        }
        this.$post('follow_comment', {
          type: 1,//1评论2关注3收藏
          member_id: this.USER().id,
          limit: 10,
          page: this.page,
        }).then(res => {
          that.is_loading = true;
          if (res.data.data) {
            res.data.data.forEach((element, index) => {
              res.data.data[index].is_selected = false;
            });
          }
          that.list_ul = that.list_ul.concat(res.data.data);
          // that.addImg();

        })
      },
      getUser() {
        let that = this;
        this.REFRESH_USER();
        that.user = this.USER();
        that.getList();
      },
    },
    mounted() {
      this.getUser();
      let that = this;


      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var scrollHeight = $(document).height();
        var windowHeight = $(this).height();
        if (scrollTop + windowHeight + 2 >= scrollHeight) {
          that.page++;
          that.getList();
        }
      });
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .div_title {
    height: 48px;
    border-bottom: 1px solid #DFDFDF;
  }

  .div_title .title {
    font-size: 18px;
    color: #1a1a1a;
    margin-bottom: 20px;
  }

  .div_title .title_right>button {
    height: 36px;
    border-radius: 4px;
    background: #DB414E;
    color: #fff;
    font-size: 18px;
    border: 0;
    margin-left: 50px;
    width: 88px;
  }

  .div_title .title_right>button.state {
    color: #1A1A1A;
    background: #DFDFDF;
  }

  .div_title .title_right .del {
    font-size: 18px;
    color: #F24D5B;
    cursor: pointer;
  }

  .recommended_list {}

  .recommended_list .recommended_li {
    padding: 30px 25px 30px 35px;
    border-bottom: 1px solid #DFDFDF;
    cursor: pointer;
    transition: all .5s ease;
    align-items: flex-start;
    position: relative;
  }

  .recommended_list .recommended_li .time {
    width: 80px;
    font-size: 12px;
    color: #666;
  }

  .recommended_list .recommended_li .text {
    flex: 1;
    margin-left: 10px;
    font-size: 14px;
    color: #333;
    line-height: 1.6em;
    overflow:hidden;
text-overflow:ellipsis;
white-space:nowrap;

  }

  .recommended_list .recommended_li:hover {
    background: #f4f4f4;
  }

  .recommended_list .recommended_li .gou_icon {
    position: absolute;

    top: 27px;
    left: 8px;
    width: 20px;
    height: 20px;
  }

  .recommended_list .recommended_li .mark {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #333;
    position: absolute;
    top: 34px;
    left: 15px;
  }

  .recommended_list .recommended_li .text.li_r_img img {
    max-width: 80%;
  }

  /* 暂无数据 */
  .no_center {
    flex-direction: column;
    padding-top: 72px;

  }

  .no_center>i {
    width: 300px;
    margin-bottom: 40px;
  }

  .no_center .prompt_text {
    font-size: 18px;
    color: #666;
  }

  .no_center .prompt_text>a {
    color: #F24D5B;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/my_comments.vue